import _createForOfIteratorHelper from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import { isFilter } from "./positionals.js";
export function getDocumentRoot(node) {
  while (node.parent) {
    node = node.parent;
  }
  return node;
}
export function groupSelectors(selectors) {
  var filteredSelectors = [];
  var plainSelectors = [];
  var _iterator = _createForOfIteratorHelper(selectors),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var selector = _step.value;
      if (selector.some(isFilter)) {
        filteredSelectors.push(selector);
      } else {
        plainSelectors.push(selector);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return [plainSelectors, filteredSelectors];
}